import { create } from 'zustand';

/**
 * Store quản lý dữ liệu bác sĩ/chuyên gia
 * Bao gồm: danh sách bác sĩ, phân trang, bộ lọc nâng cao, trạng thái loading
 */
export const useDoctorStore = create((set, get) => ({
    // State - Trạng thái dữ liệu
    doctors: [],            // Danh sách bác sĩ hiện tại
    pageIndex: 1,          // Trang hiện tại
    hasMore: true,          // Còn dữ liệu để load thêm không
    totalItems: 0,          // Tổng số bác sĩ
    isLoading: false,       // Trạng thái loading

    // Bộ lọc tìm kiếm nâng cao
    filters: {
        keyword: '',           // Từ khóa tìm kiếm (tên bác sĩ)
        departmentId: '',       // ID chuyên khoa
        educationLevelId: '',   // ID trình độ học vấn
        businessId: '',          // ID bệnh viện/cơ sở y tế
        locale: ''              // Ngôn ngữ hiện tại
    },

    // Actions - Các hành động cập nhật state

    // Cập nhật bộ lọc
    setFilters: (patch) => set(state => ({
        filters: { ...state.filters, ...patch }
    })),

    // Thiết lập danh sách bác sĩ mới (thay thế hoàn toàn)
    setDoctors: (items, total, page, pageSize = 10) => set(() => ({
        doctors: items || [],                              // Danh sách bác sĩ mới
        totalItems: total || 0,                           // Tổng số bác sĩ
        pageIndex: page || 1,                              // Trang hiện tại
        hasMore: (page || 1) * pageSize < (total || 0),   // Còn dữ liệu để load thêm
        isLoading: false                                   // Tắt loading
    })),

    // Thêm bác sĩ vào danh sách hiện tại (load more)
    appendDoctors: (items, total, page, pageSize = 10) => set(state => ({
        doctors: [...state.doctors, ...(items || [])],   // Nối thêm vào danh sách cũ
        totalItems: total || state.totalItems,             // Cập nhật tổng số
        pageIndex: page || state.pageIndex,                // Cập nhật trang hiện tại
        hasMore: (page || state.pageIndex) * pageSize < (total || state.totalItems), // Kiểm tra còn dữ liệu
        isLoading: false                                   // Tắt loading
    })),

    // Cập nhật trạng thái loading
    setLoading: (loading) => set({ isLoading: loading }),

    // Reset bộ lọc về trạng thái ban đầu
    resetFilters: () => set(state => ({
        filters: {
            keyword: '',                    // Xóa từ khóa
            departmentId: '',               // Xóa chuyên khoa
            educationLevelId: '',           // Xóa trình độ học vấn
            businessId: '',                  // Xóa bệnh viện
            locale: state.filters.locale    // Giữ nguyên ngôn ngữ
        }
    })),

    // Kiểm tra có bộ lọc nào đang active không
    hasActiveFilters: () => {
        const state = get();
        return state.filters.keyword ||           // Có từ khóa tìm kiếm
            state.filters.departmentId ||         // Có chọn chuyên khoa
            state.filters.educationLevelId ||     // Có chọn trình độ học vấn
            state.filters.businessId;              // Có chọn bệnh viện
    }
}));


